import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket: Socket;

  constructor() {
    this.socket = io('http://75.119.142.187:3001', {
      transports: ['websocket'],
    });

    this.socket.on('connect', () => {
      console.log('✅ Connected with ID:', this.socket.id);
    });

    this.socket.on('disconnect', () => {
      console.log('❌ Disconnected from server');
    });
  }

  // Emit register user
  registerUser(username: string, callback: (res: any) => void): void {
    this.socket.emit('registerUser', username, callback);
  }

  // Send message to recipient
  sendMessage(to: string, msg: string, callback: (res: any) => void): void {
    this.socket.emit('sendMessage', { to, msg }, callback);
  }

  // Listen for incoming messages
  onMessage(callback: (msg: any) => void): void {
    this.socket.on('newMessage', callback);
  }
}
